import { API } from "aws-amplify";
import React, { Component } from "react";
import {  Modal, Button } from "react-bootstrap";
import PropertyIntegrationsList from "containers/property/PropertyIntegrationsList";



export default class PropertyIntegrationsModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            
        };

        
     
       
    }
    

    async componentDidMount() {
        console.log("In AddressMatchingModal componentDidMount");
        if (!this.props.isAuthenticated) { // if false
            return;
        }

        if (!this.props.show) {
            return null;
        }

           
    }

    async getTitleDetails() {
        this.props.getTitleDetails()
    }

    componentWillUnmount() {
        this.getTitleDetails()
        this.setState({ entities: [] });
    }

    async deleteAll(event) {
        if ((this.props.data||[]).length === 0) {
            return;
        }

        const confirm = window.confirm('Are you sure you want to delete all Equivalent Properties?');

        if (!confirm) {
            return;
        }

        const data = [...this.props.data].map(data => {return {...data, archived_date: new Date().toISOString()}});

        if (this.props.ctx === 'cs') {
            await API.put('colin', `/properties/${this.props.filter.propertyid}/integrations_bulk/null`, { body: data });
        } else if (this.props.ctx === 'slmsale') {
            await API.put('colin', `/slmsales/${this.props.filter.saleid}/integrations_bulk/null`, { body: data });
        } else if (this.props.ctx === 'slmlease') {
            await API.put('colin', `/slmleases/${this.props.filter.leaseid}/integrations_bulk/null`, { body: data });
        }

        this.props.updateTableState([], 'integrations');
    }
    

    renderAddresses() {
        return (
            
            <Modal
                show={this.props.show}
                onHide={this.props.toggleAddressModal}
                dialogClassName="modal-90w"
                >
                <Modal.Header closeButton>
                    <Modal.Title>CoreLogic Equivalent Properties</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ 'overflowX': 'scroll' }}>
           
                        <div class="text-right mb-1">
                            <Button type="button" size="sm" variant="danger" onClick={(e) => this.deleteAll(e)}>Delete All</Button>               
                        </div>

                        <PropertyIntegrationsList
                        filter={this.props.filter}
                        isAuthenticated={this.props.isAuthenticated}
                        isLoading={this.state.isLoading}
                        controlType="table"
                        saveForm={this.props.saveForm}
                        user={this.props.user}
                        data={this.props.data}
                        updateTableState={this.props.updateTableState}
                        saveRecord={this.props.saveRecord}
                        deleteRecord={this.props.deleteRecord}
                        validateRelatedRecord={this.props.validateRelatedRecord}
                        streetOptions={this.props.streetOptions}
                        acceptIntegration={this.props.acceptIntegration}
                        rejectIntegration={this.props.rejectIntegration}
                        ctx={this.props.ctx}
                        />

                  
          
                    </Modal.Body>
            </Modal>
        );
    }
    
    


    render() {
        return (

            <div className="AddressEdit">
                {this.props.isAuthenticated ? this.renderAddresses() : console.log("error)")}
            </div>
        );
    }
}
